module.exports = __webpack_public_path__ + "static/media/infoDots.392272d4.svg";